// Catalogo delle esportazioni multiple (sezione ponti — ExportStructuresPanel.jsx,
// pulsante "Esporta Elenco Ponti" in StructuresList.jsx). Estratto in un file a
// parte (prima era un array locale al componente) per essere riusabile anche da
// Admin > Gestione Utenti > Dettaglio Utente, campo "Export addizionali - Elenco
// ponti" — unica fonte, nessuna lista duplicata a mano.
//
// Task 34 — valori allineati a `ExportType` (apps/api/src/enums/export-type.enum.ts),
// stesso ruolo di `ExportOptions` in ExportSelect/constants.js ma per lo scope
// multi-ponte (39-43): prima erano 3/4/5/6/'tree', locali a questo solo file,
// ora sono gli stessi id usati da PUT users/:id/additional-exports
// (additionalExportsMultiple) — niente rimappatura in quel punto.
export const MultipleExportType = {
  CustomCsv: 39, // Personalizzata (ex 'tree')
  CsvMaintenance: 40, // csv Manutenzione (ex 5)
  AinopCsvBaseRegistry: 41, // AINOP - csv L0_Anagrafica base (ex 3)
  AinopCsvRoadBridgesViaducts: 42, // AINOP - csv L0_Ponti e Viadotti stradali (ex 4)
  AinopCsvL1L2: 43, // AINOP - csv L1,2 (ex 6)
};

export const MultipleExportOptions = [
  { label: 'csv Manutenzione', value: MultipleExportType.CsvMaintenance },
  { label: 'Personalizzata', value: MultipleExportType.CustomCsv },
  {
    label: 'AINOP - csv L0_Anagrafica base',
    value: MultipleExportType.AinopCsvBaseRegistry,
  },
  {
    label: 'AINOP - csv L0_Ponti e Viadotti stradali',
    value: MultipleExportType.AinopCsvRoadBridgesViaducts,
  },
  { label: 'AINOP - csv L1,2', value: MultipleExportType.AinopCsvL1L2 },
];
